import { formatDateAdaptive } from '@/infrastructure/utils/digit';
import { formatDate } from '@/infrastructure/utils/timestamp';
import { Option } from '@/proto/field';
import { MetricSubType } from '@/proto/metric';


export enum SortType  {
  DESC='DESC'
}

export enum ReportOrEvent{
  ReportTime='report_time',
  EventTime='event_time'
}

export const TIME_LIST = [ReportOrEvent.ReportTime, ReportOrEvent.EventTime];

const DATE_FORMAT = 'YYYY/MM/DD HH:mm:ss';

export const ALARM_TYPE = [
  { value: 0, label: 'wake_up唤醒' },
  { value: 1, label: 'alarm唤醒' },
  { value: 2, label: 'wake_up唤醒' },
  { value: 3, label: 'alarm唤醒' },
];

export enum ElementEnum {
  Alarm = 'alarm',
  WakeLock = 'wake_lock',
  Location = 'location',
}

export const  batteryFactor: Record<string, any> = {
  alarm: {
    text: 'Alarm',
    unitStr: '唤醒次数',
    options: [
      {
        label: '上报时间',
        value: ReportOrEvent.ReportTime,
        sorter: {
          sortField: 'report_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: '发生时间',
        value: ReportOrEvent.EventTime,
        sorter: {
          sortField: 'event_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: '周期累计wake_up唤醒次数',
        value: 'wakeup_frequency',
        sorter: {
          sortField: 'wakeup_frequency',
          sortType: SortType.DESC,
        },
      },
      {
        label: '周期累计alarm唤醒次数',
        value: 'frequency',
        sorter: {
          sortField: 'frequency',
          sortType: SortType.DESC,
        },
      },
    ],
  },
  wake_lock: {
    text: 'WakeLock',
    unitStr: '持有时长',
    options: [
      {
        label: '上报时间',
        value: ReportOrEvent.ReportTime,
        sorter: {
          sortField: 'report_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: '发生时间',
        value: ReportOrEvent.EventTime,
        sorter: {
          sortField: 'event_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: '单次持有最大时长',
        value: 'single_max_duration_in_ms',
        sorter: {
          sortField: 'single_max_duration_in_ms',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDateAdaptive(text),
      },
      {
        label: '周期累计持有次数',
        value: 'frequency',
        sorter: {
          sortField: 'frequency',
          sortType: SortType.DESC,
        },
      },
      {
        label: '周期累计持有时长',
        value: 'duration_in_ms',
        sorter: {
          sortField: 'duration_in_ms',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDateAdaptive(text),
      },
    ],
  },
  location: {
    text: '定位',
    unitStr: '定位时长',
    options: [
      {
        label: '上报时间',
        value: ReportOrEvent.ReportTime,
        sorter: {
          sortField: 'report_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: '发生时间',
        value: ReportOrEvent.EventTime,
        sorter: {
          sortField: 'event_time',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDate(text, DATE_FORMAT),
      },
      {
        label: '单次定位最大时长',
        value: 'single_max_duration_in_ms',
        sorter: {
          sortField: 'single_max_duration_in_ms',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDateAdaptive(text),
      },
      {
        label: '周期累计定位次数',
        value: 'frequency',
        sorter: {
          sortField: 'frequency',
          sortType: SortType.DESC,
        },
      },
      {
        label: '周期累计定位时长',
        value: 'duration_in_ms',
        sorter: {
          sortField: 'duration_in_ms',
          sortType: SortType.DESC,
        },
        render: (text: any) => formatDateAdaptive(text),
      },
    ],
  },
};

export const SUB_METRIC_OPTIONS = [
  { label: '异常次数', value: MetricSubType.SUB_TYPE_COUNT },
  { label: '次数样本量', value: MetricSubType.SUB_TYPE_DAU_COUNT },
  { label: '异常设备数', value: MetricSubType.SUB_TYPE_DEVICE_UV },
  { label: '设备样本量', value: MetricSubType.SUB_TYPE_DAU_DEVICE_UV },
];
export const DIMENSION_OPTIONS = [
  { label: 'APP版本', value: 'app_version', color: '#3385FF' },
  { label: '机型', value: 'model', color: '#52B7FF' },
  { label: '系统版本', value: 'os_version', color: '#60DBB4' },
  { label: 'Bundle ID', value: 'bundle_id', color: '#3385FF' },
  { label: '进程', value: 'process_name', color: '#52B7FF' },
  { label: '厂商', value: 'brand', color: '#60DBB4' },
  { label: '异常类型', value: 'exception_type', color: '#3385FF', renderField: (field: string): string => EXCEPTION_TYPE_OPTION.find(item => item.value === field)?.label || field },
];


export const EXCEPTION_TYPE_OPTION: Option[] = [
  {
    label: '单次定位时长超阈值',
    value: 'single_location_duration_exceed',
  },
  {
    label: '周期累计定位次数超阈值',
    value: 'sum_location_frequency_exceed',
  },
  {
    label: '周期累计定位时长超阈值',
    value: 'sum_location_duration_exceed',
  },
  {
    label: '单次持有Wake Lock时长超阈值',
    value: 'single_wake_lock_duration_exceed',
  },
  {
    label: '周期累计持有Wake Lock次数超阈值',
    value: 'sum_wake_lock_frequency_exceed',
  },
  {
    label: '周期累计持有Wake Lock时长超阈值',
    value: 'sum_wake_lock_duration_exceed',
  },
  {
    label: '周期累计wake_up类型Alarm唤醒次数超阈值',
    value: 'sum_wakeup_alarm_frequency_exceed',
  },
  {
    label: '周期累计Alarm唤醒次数超阈值',
    value: 'sum_alarm_frequency_exceed',
  },
];


